import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0df99da0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    class: "PopupHeadline px-2 py-4 bg-brand_beige_light text-center",
    style: { "position": "sticky", "z-index": "2", "top": "0" }
};
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "h5-responsive strong p-0 m-0 d-inline-block" }, [
    /*#__PURE__*/ _createElementVNode("img", {
        src: "/images/_new_brand/icons/icon_success.svg",
        class: "icon",
        alt: "OK"
    }),
    /*#__PURE__*/ _createTextVNode(" Deine Verkaufsanfrage: ")
], -1));
const _hoisted_3 = ["onClick"];
const _hoisted_4 = { class: "pt-5 px-5 pb-3 font5-responsive" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "icon-barcode h1" }, null, -1));
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "mb-3" }, "Gib hier die EAN-Nummer deines Produktes ein, daß du verkaufen möchtest:", -1));
import eventBus from '@/services/EventBus';
import { ref, onMounted, computed } from 'vue';
import BaseEmailInput from '@/components/Base/Forms/Inputs/BaseEmailInput.vue';
import BaseInput from '@/components/Base/Forms/Inputs/BaseInput.vue';
import { stringRequiredRule } from '@/helpers/ValidationRules';
import axios from '@/services/api/axios';
export default /*#__PURE__*/ _defineComponent({
    __name: 'RedProductRequestPopup',
    props: {
        customersEmailAddress: {
            required: false,
            type: String,
        },
    },
    setup(__props) {
        var _a;
        onMounted(() => {
            eventBus.on('openRedProductRequestPopup', triggerOpenPopup);
            eventBus.on('closeRedProductRequestPopup', triggerClosePopup);
        });
        const triggerOpenPopup = () => {
            openPopup.value = true;
        };
        const triggerClosePopup = () => {
            openPopup.value = false;
        };
        const props = __props;
        const openPopup = ref(false);
        const ean = ref('');
        const email = ref((_a = props.customersEmailAddress) !== null && _a !== void 0 ? _a : '');
        // Input fields are valid check:
        const eanValid = ref(false);
        const emailValid = ref(false);
        // Falls schon eine E-Mail vorhanden ist, (user ist angemeldet), dann initial true:
        if (email.value !== '') {
            emailValid.value = true;
        }
        const submitPossible = computed(() => {
            return emailValid.value && eanValid.value;
        });
        const searchRequest = () => {
            if (!submitPossible.value) {
                return;
            }
            openPopup.value = false;
            axios
                .post('/verkaufen/requestProduct', {
                mail: email.value,
                ean: ean.value,
            })
                .then(() => {
                eventBus.emit('openInfoPopup', {
                    icon: 'success',
                    headline: 'Deine Anfrage wurde verschickt',
                    message: 'Je nach Anfrageaufkommen versuchen wir dir innerhalb der nächsten 48 Std. zu antworten!',
                });
            })
                .catch((error) => {
                // if customer is too lazy to use search, we do it
                if (error.response.status === 302) {
                    const url = '/verkaufen/bewertung/suche__' + error.response.data.id;
                    window.location.replace(url);
                    return;
                }
                eventBus.emit('openInfoPopup', {
                    icon: 'error',
                    headline: 'Das hat leider nicht geklappt',
                    message: 'Leider konnte unser System keine Preise für dieses Produkt finden. Falls Du das Produkt trotzdem zum Verkauf anfragen möchtest, nutze bitte unser Kontaktformular.',
                    buttonDenyText: 'Abbrechen',
                    buttonDenyFunction: () => {
                        eventBus.emit('closeInfoPopup');
                    },
                    buttonConfirmText: 'Okay',
                    buttonConfirmFunction: () => {
                        eventBus.emit('closeInfoPopup');
                        eventBus.emit('openContactPopup');
                    },
                });
            });
        };
        return (_ctx, _cache) => {
                                                                  
                                                                      
            return (_openBlock(), _createBlock(_component_v_dialog, {
                class: "redProductRequestPopup",
                modelValue: openPopup.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((openPopup).value = $event)),
                width: "500",
                "max-height": "80vh"
            }, {
                default: _withCtx(({ isActive }) => [
                    _createVNode(_component_v_card, null, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _hoisted_2,
                                _createElementVNode("i", {
                                    onClick: ($event) => (isActive.value = false),
                                    class: "icon-cancel pointerhover float-right pr-2"
                                }, null, 8, _hoisted_3)
                            ]),
                            _createElementVNode("div", _hoisted_4, [
                                _hoisted_5,
                                _hoisted_6,
                                _createVNode(BaseInput, {
                                    class: "showValidationErrorsCssOverride mb-3",
                                    rules: _unref(stringRequiredRule),
                                    modelValue: ean.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((ean).value = $event)),
                                    label: "EAN Nummer",
                                    name: "ean",
                                    onChanged: _cache[1] || (_cache[1] = (event) => (eanValid.value = event.valid))
                                }, null, 8, ["rules", "modelValue"]),
                                true
                                    ? (_openBlock(), _createBlock(BaseEmailInput, {
                                        key: 0,
                                        class: "showValidationErrorsCssOverride",
                                        id: "email",
                                        modelValue: email.value,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((email).value = $event)),
                                        name: "E-Mail",
                                        onChanged: _cache[3] || (_cache[3] = (event) => (emailValid.value = event.valid))
                                    }, null, 8, ["modelValue"]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", { class: "row px-5 pb-5" }, [
                                _createElementVNode("div", { class: "col-12" }, [
                                    _createElementVNode("button", {
                                        onClick: searchRequest,
                                        class: "buttonBase buttonGreen w-100",
                                        type: "button"
                                    }, " Suchen ")
                                ])
                            ])
                        ]),
                        _: 2
                    }, 1024)
                ]),
                _: 1
            }, 8, ["modelValue"]));
        };
    }
});


/* Vuetify */
import { VCard as _component_v_card } from "vuetify/lib/components/VCard/index.mjs"
import { VDialog as _component_v_dialog } from "vuetify/lib/components/VDialog/index.mjs"

